import { Header } from 'Components/core';
import { SubHeader, TitleHeader } from 'Components/core/Header';
import InfoBox from 'Components/InfoBox';
import { colors } from 'Constants';
import React, { useEffect, useState } from 'react';
import { async } from 'regenerator-runtime';
import { getAllCompanies } from 'Root/Libs/http';
import styled from 'styled-components';
import additonalSchools from './AdditionalSchools';
import ComingSoon from './images/idchooser.jpeg';


 

const select = 'select...';

const SelectHolder=styled.div`

margin:50px ;
@media  (max-width:400px) {
  margin:0px;
}

`;

const MobileHide=styled.div`

 display:flex ;
@media  (max-width:400px) {
 display:none ;
}

`;




export default () => {
  const [schools, setSchools] = useState([]);

  useEffect(() => {
    document.title=`Anthem Student Advantage`;
    getAllCompanies().then(({ companies }) => {
      let schools = companies.sort((a, b) => {
        return a.id.localeCompare(b.id);
      }).filter(a=>a.published_date);
      setSchools(schools);
    });
  }, []);

  const doSelect = e => {
  

    /**
     * @type {string}
     */
    const selected=e.target.value;
    if(selected.indexOf("http")===0)
    {
        location.replace(selected);
    }
    else if (select != selected) {
      location.replace(`/?id=${selected}`);
    }
    
  };

  return (
    <div style={{ margin: 'auto' }}>
      <div
        style={{
          position: 'absolute',
          zIndex: 3,
          width:'100%',
          flexWrap:'wrap',

          display: 'flex',
     
          padding: 10,
          marginTop: 200,
         
        }}
      >
        <MobileHide style={{flex:.2}}></MobileHide>
        <div
          style={{
            
            flex:1,
            maxWidth:600,
            backgroundColor: '#ffffff',
            borderRadius: 2
          }}
        >
          <div
            style={{
              
              padding: 20,
             
        
              fontSize: 20
            }}
          >
              <TitleHeader>   Anthem 
                <SubHeader>Student Advantage</SubHeader>

              </TitleHeader>
          </div>
          <div style={{ margin: 20 }}>
            <div>
              The health plan designed specifically for college students. <br />{' '}
              Now it’s easier than ever to get student-minded, school-friendly,
              access-focused care.
            </div>
            <div style={{ marginTop: 20 }}>
              Select your school from the drop down list below to learn more:
            </div>
            <SelectHolder style={{ marginTop: 20,display:'flex',justifyContent:'space-around' }}>
              <select   onChange={doSelect} style={{ width:'100%',flex:1 }}>
              
              <optgroup label="School Sites">
              <option>{select}</option>
              {schools.map(school => (
                  <option value={school.id} key={school.id}>{school.id}</option>
                ))}
              </optgroup>
              <optgroup label="Additional School Sites">
              {additonalSchools.map(school => (
                  <option value={school[1]} key={school[1]}>{school[0]}</option>
                ))}
              </optgroup>

              </select>
            </SelectHolder>
          </div>
        </div>
        <MobileHide style={{      flex:1.5,}}>

        </MobileHide>
      </div>
      <div style={{ position: 'absolute' }}>
        <img
          src={ComingSoon}
          style={{
            position: 'absolute',
            width: '100vw',
            height: '100vh',
            objectFit: 'cover',
            zIndex: 1
          }}
        />
      </div>
    </div>
  );
};
